// Global Instructions Rule Applied!
//
// Configuration → Pipelines: shared stage library row (view__stage_library).
// usage_count drives the delete guard; used_by / deal_count tell the Pipeline
// Stages panel what an edit to this SHARED row is about to touch.
// passthrough() for resilience.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const StageUsedByPipelineSchema = z
  .object({
    pipelines__id: z.string(),
    pipelines__name: z.string().nullish()
  })
  .passthrough()

export type StageUsedByPipeline = z.infer<typeof StageUsedByPipelineSchema>

export const StageLibrarySchema = z
  .object({
    pipeline_stages__id: z.string(),
    pipeline_stages__name: z.string().nullish(),
    pipeline_stages__colour: z.string().nullish(),
    pipeline_stages__type: z.string().nullish(),
    pipeline_stages__type__label: z.string().nullish(),
    pipeline_stages__decision_status: z.string().nullish(),
    pipeline_stages__decision_status__label: z.string().nullish(),
    pipeline_stages__sequence: z.number().nullish(),
    pipeline_stages__usage_count: z.number().nullish(),
    // Defaulted so a backend still running the pre-extension RPC body keeps
    // validating — the panel just shows an empty used-by list.
    pipeline_stages__used_by: z.array(StageUsedByPipelineSchema).nullish().default([]),
    pipeline_stages__deal_count: z.number().nullish().default(0)
  })
  .passthrough()

export type StageLibraryModel = z.infer<typeof StageLibrarySchema>

export function validateStageLibrary(data: unknown): StageLibraryModel {
  return validateWithZodSchema(StageLibrarySchema, data, 'stage library') as StageLibraryModel
}
